
<div>
  <strong>Manage Licenses</strong> / 
</div>
<hr class="hrDiv">
<div class="page-container">
  <div class="topSectnDiv">
    <div class="floatLeft">
      <h1>Manage Licenses</h1><br>
      <p class="introCls" [innerHTML]='introMessage'></p>
    </div>
    
  </div>
  <div class="container" *ngIf="!loaded"><mat-spinner></mat-spinner></div>
  <div class="panel-container" *ngIf="loaded">
    <div class="panel-div" *ngFor="let product of productList">
      <mat-expansion-panel class="panel-cls"  expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h2 class="purple-clr">{{product}}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="tableCls horiz-scrl">
          <form [formGroup] = "licenseForm">
            <ng-container formArrayName="licenseList"> 
              <table mat-table [dataSource]="dataSource">
                <caption>
                  <div class="submit-button floatLeft">
                    <button mat-fab extended class="btn-cls" (click)="addLicensee(product)">Add Licensee</button>
                  </div>
                  <div class="floatRight">
                  <mat-paginator #licPag 
                      *ngIf="loaded"
                      [length]="licenseList.length"
                      [pageSizeOptions]="[5, 10, 20]" 
                      showFirstLastButtons
                      aria-label="Select page of licensees">
                  </mat-paginator>
                </div>
                </caption> <br>
                
                <ng-container matColumnDef="fName">
                  <th mat-header-cell *matHeaderCellDef> First Name </th>
                  <td mat-cell *matCellDef="let element let i = index" [formGroup]="element" class="width27">
                    <!--
                    <div *ngIf="licenseList.value[i+(licPag.pageIndex*licPag.pageSize)].selected" class="inlineFldCls">
                      <mat-form-field>
                        <input matInput type="text" formControlName="firstName"/>
                      </mat-form-field>
                    </div>
                    -->
                    <div>
                      {{element.value.firstName}}
                    </div>
                  </td>
                  </ng-container>
            
                <ng-container matColumnDef="lName">
                  <th mat-header-cell *matHeaderCellDef> Last Name </th>
                  <td mat-cell *matCellDef="let element let i = index" [formGroup]="element" class="width27">
                    <!--
                    <div *ngIf="licenseList.value[i+(licPag.pageIndex*licPag.pageSize)].selected" class="inlineFldCls">
                      <mat-form-field>
                        <input matInput type="text" formControlName="lastName"/>
                      </mat-form-field>
                    </div>
                    -->
                    <div>
                      {{element.value.lastName}}
                    </div>
                  </td>
                </ng-container>
            
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef required-field> Email </th>
                    <td mat-cell *matCellDef="let element let i = index" [formGroup]="element" class="width27">
                    <!--
                    <div *ngIf="licenseList.value[i+(licPag.pageIndex*licPag.pageSize)].selected" class="inlineFldCls">
                      <mat-form-field>
                        <input matInput type="text" formControlName="email"/>
                        <mat-error *ngIf="email?.hasError('alreadyExists')">
                          User or Email already exists
                        </mat-error>
                      </mat-form-field>
                    </div>
                    -->  
                    <div>
                      {{element.value.email}}
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="admin">
                  <th mat-header-cell *matHeaderCellDef> Admin </th>
                  <td mat-cell *matCellDef="let element let i = index" [formGroup]="element">
                    <div>
                      {{element.value.accessType === 'AdministratorWithAccess' ? 'Yes':'No'}}
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef> Action </th>
                  <td mat-cell *matCellDef="let element let i = index">
                    <span>
                    <mat-icon class="icon-cls" aria-hidden="false" matTooltip="Delete" fontIcon="delete"
                    (click)="deleteLicense(i, product)" ></mat-icon>
                  </span>
                  <!--
                  <span>                  
                   <mat-icon class="icon-cls floatLeft paddingRight40" matTooltip="Save" aria-hidden="false" 
                      fontIcon="save" (click)="saveEdit(i, product)"></mat-icon>
                    
                    <mat-icon class="icon-cls" aria-hidden="false" matTooltip="Cancel" fontIcon="cancel"
                      (click)="cancel(i)" ></mat-icon>
                  </span>
                  -->  
                  </td>
                </ng-container>
            
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true"></tr>
                <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
              
              </table>
            </ng-container>
          </form>
        </div>

        <ng-template #addLicenseeDialog>
          <h1 mat-dialog-title>Add Licensee</h1>  
          <div mat-dialog-content class="horiz-scrl">
            <form [formGroup]="addLicenseForm" class="padding-left-20">
              <div>
                <span>
                  <label class="pd-label required-field">First Name</label>
                  <div>
                    <mat-form-field>
                      <input  matInput formControlName="firstName" >
                    </mat-form-field>
                  </div>
                </span>
                <span>
                  <label class="pd-label required-field">Last Name</label>
                  <div>
                    <mat-form-field>
                      <input  matInput formControlName="lastName" >
                    </mat-form-field>
                  </div>
                </span>
                <span>
                  <label class="pd-label required-field">Email</label>
                  <div>
                    <mat-form-field>
                      <input  matInput formControlName="email" >
                      <mat-error *ngIf="emailForAdd?.hasError('alreadyExists')">
                        User or Email already exists
                      </mat-error>
                    </mat-form-field>
                  </div>
                </span>
              </div><br>
            </form>
            <div class="msg-cls padding-left-20"> 
              {{msgText}}
            </div>
          </div>
          <mat-dialog-actions class="padding-left-40">
            <div class="submit-button">
              <button mat-fab extended class="btn-cls" [disabled]="disableSaveBtn()" 
                (click)="saveData()">Save</button> 
              <button mat-fab extended class="btn-cls" (click)="cancelAdd()">
                Cancel</button> 
            </div>
          </mat-dialog-actions>
        </ng-template>
      </mat-expansion-panel>
    </div>
    
  </div>
 
</div>